module.exports = __webpack_public_path__ + "media/ndtAdLow.98c10d45.mp4";